export const HEADER_HEIGHT = 64
export const SIDEBAR_WIDTH = 280
